// extracted by mini-css-extract-plugin
export default {"root":"Tiles_root__TErHN"};